module.exports = __webpack_public_path__ + "static/media/goldenprize-tuna-soyabean-lid.9b3a0542.png";